<div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" fxLayout="column" fxLayoutGap="10px">
  <div class="flex-row" class="page-header">
    <div class="flex-cell">Bloqueo de remitos basado en TPRE
    </div>
  </div>
  <article class="table-header" *ngIf="canAddOrEdit">
    <button class="button1" color="primary" mat-icon-button (click)="addRow()">
      <mat-icon title='Agregar fila'>add_circle</mat-icon>
    </button>
    <button class="button1" color="primary" mat-icon-button (click)="save()" [disabled]="saveButtonDisabled">
      <mat-icon title='Salvar'>save</mat-icon>
    </button>
  </article>

  <div #tableContainer class="table-container">
    <table mat-table matSort [dataSource]="dataSource">
      <ng-container matColumnDef="codTpre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cód TPRE
          <fab-string-filter #tableFilter columnDef="codTpre"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div class="cell-width-mtext" *ngIf="!element.isAdd">
            {{element.codTpre}}
          </div>
          <mat-form-field #codTpreField class="cell-width-mtext" *ngIf="element.isAdd " appearance="fill">
            <input matInput required minlength="2" maxlength=2 [(ngModel)]="element.codTpre " autocomplete="off"
                   (change)="checkId(element, codTpreField)"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'codTpre')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="descTpre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción
          <fab-string-filter #tableFilter columnDef="descTpre"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-description">
          <div class="cell-width-description" *ngIf="!element.isAdd && !element.isEdit">
            {{element.descTpre}}
          </div>
          <mat-form-field class="cell-width-description" *ngIf="element.isAdd || element.isEdit" appearance="fill">
            <input matInput required minlength="1" maxlength=50 [(ngModel)]="element.descTpre" autocomplete="off"/>
            <mat-icon matPrefix *ngIf="isDirty(element,'descTpre')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-form-field>
        </td>
      </ng-container>


      <ng-container matColumnDef="onHold">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header>On Hold
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div class="cell-width-mtext" *ngIf="!element.isAdd && !element.isEdit">
            <mat-checkbox disabled [checked]="element.onHold"></mat-checkbox>
          </div>
          <mat-checkbox class="cell-width-mtext" [(ngModel)]="element.onHold" *ngIf="element.isAdd || element.isEdit">
            <mat-icon matPrefix *ngIf="isDirty(element,'onHold')"
                      color="warn" class="dirty-indicator">info
            </mat-icon>
          </mat-checkbox>
        </td>
      </ng-container>


      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef scope="col" mat-sort-header> Estado
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-lgtext">
          <div *ngIf="!element.isEdit; else statusBox">
            <span *ngIf="element.estado">Active</span>
            <span *ngIf="!element.estado">Inactive</span>
          </div>
          <ng-template #statusBox>
            <mat-form-field appearance="fill" class="cell-width-lgtext">
              <mat-select [(ngModel)]="element.estado" name="estado">
                <mat-option [value]=true>
                  Active
                </mat-option>
                <mat-option [value]=false>
                  Inactive
                </mat-option>
              </mat-select>
              <mat-icon matPrefix *ngIf="isDirty(element,'estado')"
                        color="warn" class="dirty-indicator">info
              </mat-icon>
            </mat-form-field>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="fecCreacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Creación
          <fab-date-filter #tableFilter columnDef="fecCreacion" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.fecCreacion  | date:'dd/MM/yyyy'}}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="usrCreacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Creación
          <fab-string-filter #tableFilter columnDef="usrCreacion"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.usrCreacion}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="fecModif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Modificación
          <fab-date-filter #tableFilter columnDef="fecModif" [operators]="dateOperators"
                           (filterChange)="filterChange($event);"></fab-date-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.fecModif  | date:'dd/MM/yyyy'}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="usrModif">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Usu Modificación
          <fab-string-filter #tableFilter columnDef="usrModif"
                             (filterChange)="filterChange($event);"></fab-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-mtext">
          <div>
            {{element.usrModif}}
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="isEdit">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-smtext">
          <div class="btn-edit" *ngIf="canAddOrEdit">
            <div *ngIf="!element.isEdit && !element.isAdd">
              <button class="button1" color="secondary" mat-icon-button (click)="editRow(element)">
                <mat-icon title='Edit'>create</mat-icon>
              </button>
            </div>
          </div>
          <div class="btn-edit" *ngIf="canAddOrEdit">
            <div *ngIf="element.isEdit || element.isAdd">
              <button class="button1" color="tertiary" mat-icon-button (click)="cancelRow(element)">
                <mat-icon title='Edit'>cancel</mat-icon>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

    </table>

  </div>
  <mat-paginator [length]="resultsLength" [pageSize]="pageSize" [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
</div>
